document.addEventListener("DOMContentLoaded", () => {

    /* =========================================
       ELEMENTOS
    ========================================= */

    const filtroTipo = document.getElementById("filtro-tipo-select");
    const filtroOrden = document.getElementById("filtro-orden-select");

    const barraPrecio = document.getElementById("barra-precio");
    const precioActual = document.getElementById("precio-actual");

    const contenedorProductos = document.querySelector(".articulo-recultados-tarjetas");

    const productos = Array.from(
        document.querySelectorAll(".tarjeta-producto-resultados")
    );

    /* =========================================
       FORMATEAR PRECIO
    ========================================= */

    function formatearPrecio(numero) {

        return Number(numero).toLocaleString("es-MX");

    }

    /* =========================================
       ACTUALIZAR TEXTO PRECIO
    ========================================= */

    precioActual.textContent =
        `$${formatearPrecio(barraPrecio.value)}`;

    barraPrecio.addEventListener("input", () => {

        precioActual.textContent =
            `$${formatearPrecio(barraPrecio.value)}`;

        aplicarFiltros();

    });

    /* =========================================
       EVENTOS
    ========================================= */

    filtroTipo.addEventListener("change", aplicarFiltros);
    filtroOrden.addEventListener("change", aplicarFiltros);

    /* =========================================
       FUNCIÓN FILTRAR
    ========================================= */

    function aplicarFiltros() {

        const tipoSeleccionado = filtroTipo.value;
        const precioMaximo = parseFloat(barraPrecio.value);
        const ordenSeleccionado = filtroOrden.value;

        let productosVisibles = [];

        productos.forEach((producto) => {

            /* =========================================
               DATOS PRODUCTO
            ========================================= */

            const titulo =
                (producto.dataset.titulo || "").toLowerCase();

            const precio =
                parseFloat(producto.dataset.precio) || 0;

            let coincideTipo = false;

            /* =========================================
               FILTRO TIPO
            ========================================= */

            if (tipoSeleccionado === "todos") {

                coincideTipo = true;

            }

            else if (tipoSeleccionado === "6-sillas") {

                coincideTipo =
                    titulo.includes("6") ||
                    titulo.includes("seis");

            }

            else if (tipoSeleccionado === "4-sillas") {

                coincideTipo =
                    titulo.includes("4") ||
                    titulo.includes("cuatro");

            }

            else if (tipoSeleccionado === "con-banca") {

                coincideTipo =
                    titulo.includes("banca");

            }

else if (tipoSeleccionado === "sillas") {
    // Asegura limpiar espacios y buscar solo sillas sueltas
    coincideTipo = titulo.trim().includes("silla") && !titulo.includes("antecomedor");
}
else if (tipoSeleccionado === "bancas") {
    coincideTipo = titulo.includes("banca") && !titulo.includes("antecomedor");
}
            /* =========================================
               FILTRO PRECIO
            ========================================= */

            const coincidePrecio =
                precio <= precioMaximo;

            /* =========================================
               MOSTRAR / OCULTAR
            ========================================= */

            if (coincideTipo && coincidePrecio) {

                producto.style.display = "flex";

                productosVisibles.push(producto);

            } else {

                producto.style.display = "none";

            }

        });

        /* =========================================
           ORDENAR
        ========================================= */

        if (ordenSeleccionado === "menor-mayor") {

            productosVisibles.sort((a, b) => {

                return (
                    parseFloat(a.dataset.precio) -
                    parseFloat(b.dataset.precio)
                );

            });

        }

        else if (ordenSeleccionado === "mayor-menor") {

            productosVisibles.sort((a, b) => {

                return (
                    parseFloat(b.dataset.precio) -
                    parseFloat(a.dataset.precio)
                );

            });

        }

        /* =========================================
           REORDENAR DOM
        ========================================= */

        productosVisibles.forEach((producto) => {

            contenedorProductos.appendChild(producto);

        });

    }

    /* =========================================
       INICIAR
    ========================================= */

    aplicarFiltros();

});